
/**
 * 推荐翻译关键词请求
 */
export interface RecommendTranslateKeywordRequest {
    /**
     * 任务ID
     */
    taskId: string;
}

/**
 * 推荐翻译关键词响应
 */
export type RecommendTranslateKeywordResponse = Content[];

export interface Content {
    /**
     * 原文
     */
    original: string[];
    /**
     * 段落
     */
    percentage: number;
    /**
     * 译文
     */
    translation: string;
    /**
     * 是否 AI 推荐
     */
    airecommend: boolean;
}

export interface RecommendTranslateKeywordApi {
    /**
     * 推荐翻译关键词
     */
    getRecommendTranslateKeyword(request: RecommendTranslateKeywordRequest): Promise<RecommendTranslateKeywordResponse>;
}

export const RecommendTranslateKeywordApi = Symbol('RecommendTranslateKeywordApi');

